import { render, staticRenderFns } from "./InputChannel.vue?vue&type=template&id=1666fa8f&scoped=true"
import script from "./InputChannel.vue?vue&type=script&lang=js"
export * from "./InputChannel.vue?vue&type=script&lang=js"
import style0 from "./InputChannel.vue?vue&type=style&index=0&id=1666fa8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1666fa8f",
  null
  
)

export default component.exports